import React, { useEffect, useState } from "react";
import { Button } from "../../../../_helpers/components/Button";
import { SideBar } from "../../../../_helpers/components/SideBar";
import { ContractForm } from "./ContractForm";
import { ListElement } from "../../../../_helpers/components/ListElement";
import { useOutletContext } from "react-router-dom";
import { createPlanning, deletePlanning } from "../../../../_api/WorkShift";
import { DefaultDropdown } from "../../../../_helpers/components/Forms/Dropdown";
import { getUserContracts } from "../../../../_api/Contract";
import { dateToAAAAMMJJ } from "../../../../_helpers/functions";
import { checkTimeSlotPresence } from "../../../../_api/TimeSlot";
import { contractsDiff } from "../../../../_helpers/contractsDiff";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { toast } from "react-hot-toast";
import { handlePlanningCreationSuccess } from "../../../../_helpers/planningHourLimitNotifications";

const ContratsTab = (props) => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["CONTRACTS_USER"]["features"];

    const { profile, refreshProfil, onDataChange } = props;

    const [contracts, setContracts] = useState([]);
    const [openSideBar, setOpenSidebar] = useState(false);
    const [sideBarTitle, setSidebarTitle] = useState("");
    const [sideBarContent, setSidebarContent] = useState("");

    const [showModalCreatePlanning, setShowModalCreatePlanning] = useState(false);
    const [showModalDeletePlanning, setShowModalDeletePlanning] = useState(false);
    const [planningCreateOperation, setPlanningCreateOperation] = useState(0);
    const [planningDeleteOperation, setPlanningDeleteOperation] = useState(0);
    const [dateCreationStart, setDateCreationStart] = useState("");
    const [dateCreationEnd, setDateCreationEnd] = useState("");
    const [isUpdatingPlanning, setIsUpdatingPlanning] = useState(false);

    const options = {
        day: "numeric",
        month: "short",
        year: "numeric",
    };

    const updateContracts = async () => {

        setPlanningCreateOperation(0);
        setPlanningDeleteOperation(0);

        const oldContracts = contracts;
        refreshProfil();

        const res = await getUserContracts(profile.id);
        const newContracts = res.data.sort((a, b) => a.start_date < b.start_date ? -1 : 1);
        setContracts(newContracts);

        const diff = contractsDiff(oldContracts, newContracts);

        let suppression = false;

        if (newContracts.length > 0) {

            const periodesSuppression = [];

            for (let i = 1; i < newContracts.length; i++) {
                const lendemain = new Date(newContracts[i - 1].end_date).setDate(new Date(newContracts[i - 1].end_date).getDate() + 1);
                const veille = new Date(newContracts[i].start_date).setDate(new Date(newContracts[i].start_date).getDate() - 1);
                if (lendemain <= veille) {
                    periodesSuppression.push(...[{ start: dateToAAAAMMJJ(lendemain, "-"), end: dateToAAAAMMJJ(veille, "-") }]);
                }
            }
            
            const checkPresenceBefore = await checkTimeSlotPresence({
                user_id: profile.id,
                states: ["PROVISIONAL", "REAL"],
                end_date: (new Date(newContracts[0].start_date).setDate(new Date(newContracts[0].start_date).getDate() - 1)) / 1000,
            });

            if (checkPresenceBefore.data.exists) {
                suppression = true;
            } else {
                if (newContracts[newContracts.length - 1].end_date) {
                    const checkPresenceAfter = await checkTimeSlotPresence({
                        user_id: profile.id,
                        states: ["PROVISIONAL", "REAL"],
                        start_date: (new Date(newContracts[newContracts.length - 1].end_date).setDate(new Date(newContracts[newContracts.length - 1].end_date).getDate() + 1)) / 1000,
                    });
                    if (checkPresenceAfter.data.exists) {
                        suppression = true;
                    }
                }
                
            }
            if (!suppression) {
                for (const periode of periodesSuppression) {
                    const checkPresence = await checkTimeSlotPresence({
                        user_id: profile.id,
                        states: ["PROVISIONAL", "REAL"],
                        start_date: new Date(periode.start).getTime() / 1000,
                        end_date: new Date(periode.end).getTime() / 1000,
                    });
                    if (checkPresence.data.exists) {
                        suppression = true;
                        break;
                    }
                }
            }
        } else {
            const checkPresenceAll = await checkTimeSlotPresence({
                user_id: profile.id,
                states: ["PROVISIONAL", "REAL"],
            });

            if (checkPresenceAll.data.exists) {
                suppression = true;
            }
        }

        if (suppression) {
            setPlanningDeleteOperation(1);
            setShowModalDeletePlanning(true);
        }
        if (diff.hasDifferences && diff.changedPeriodsInNewContracts.length > 0) {
            setDateCreationStart(dateToAAAAMMJJ(new Date(diff.changedPeriodsInNewContracts[0].start_date).getTime(), "-"));
            setDateCreationEnd(dateToAAAAMMJJ(Math.min(new Date(diff.changedPeriodsInNewContracts[diff.changedPeriodsInNewContracts.length - 1].end_date).getTime(), new Date(new Date().setFullYear(new Date().getFullYear() + 1, 11, 31)).getTime()), "-"));
            setShowModalCreatePlanning(true);
        }


    };

    const updateProvisional = async () => {
        setIsUpdatingPlanning(true);
        try {
        
        if (planningDeleteOperation != 0) {

            if (contracts.length > 0) {

                const periodesSuppression = [];

                for (let i = 1; i < contracts.length; i++) {
                    const lendemain = new Date(contracts[i - 1].end_date).setDate(new Date(contracts[i - 1].end_date).getDate() + 1);
                    const veille = new Date(contracts[i].start_date).setDate(new Date(contracts[i].start_date).getDate() - 1);
                    if (lendemain <= veille) {
                        periodesSuppression.push(...[{ start: dateToAAAAMMJJ(lendemain, "-"), end: dateToAAAAMMJJ(veille, "-") }]);
                    }
                }
                await deletePlanning(
                    { user_id: profile.id, destinations: ["PROVISIONAL", "REAL"], start_date: null, end_date: new Date(contracts[0].start_date).setDate(new Date(contracts[0].start_date).getDate() - 1) / 1000 }
                ).catch((err) => {
                    toast.error("Erreur lors de la suppression du planning");
                    console.log(err);
                });
                await deletePlanning(
                    { user_id: profile.id, destinations: ["PROVISIONAL", "REAL"], start_date: new Date(contracts[contracts.length - 1].end_date).setDate(new Date(contracts[contracts.length - 1].end_date).getDate() + 1) / 1000, end_date: null }
                ).catch((err) => {
                    toast.error("Erreur lors de la suppression du planning");
                    console.log(err);
                });
                for (const periode of periodesSuppression) {
                    await deletePlanning(
                        { user_id: profile.id, destinations: ["PROVISIONAL", "REAL"], start_date: new Date(periode.start).getTime() / 1000, end_date: new Date(periode.end).getTime() / 1000 }
                    ).catch((err) => {
                        toast.error("Erreur lors de la suppression du planning");
                        console.log(err);
                    });

                }
            } else {
                await deletePlanning(
                    { user_id: profile.id, destinations: ["PROVISIONAL", "REAL"], start_date: null, end_date: null }
                ).catch((err) => {
                    toast.error("Erreur lors de la suppression du planning");
                    console.log(err);
                });
            }
        }
        // $type_copy : "full" ou "", "if_not_absence", "if_nothing"
        if (planningCreateOperation == 0) return;
        const payload = {
            user_id: profile.id,
            start_date: dateCreationStart,
            end_date: dateCreationEnd,
            type_copy: planningCreateOperation == 1 ? "if_nothing" : (planningCreateOperation == 2 ? "if_not_absence" : "full"),
            destinations: ["PROVISIONAL"],
        };
        await createPlanning(payload).then((resp) => {
            handlePlanningCreationSuccess(resp.data);
            toast.success(resp.data.message);

        }).catch((err) => {
            toast.error("Erreur lors de la création du planning prévisionnel");
            console.log(err);
        });
        } finally {
            setIsUpdatingPlanning(false);
        }
    }

    useEffect(() => {
        if (profile) {
            setContracts(profile.contracts || []);
        }
    }, [profile]);

    useEffect(() => {
        onDataChange?.({ contracts });
    }, [contracts]);

    return (
        <div className="space-y-6">
            {/* Section Contrats */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center">
                        <div className="flex items-center justify-center w-10 h-10 bg-indigo-100 rounded-lg mr-3">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6 text-indigo-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                            </svg>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900">
                            Contrats et cycles
                        </h3>
                    </div>
                    <Button
                        id="add"
                        type="empty"
                        isVisible={features_right['contract_management']}
                        action={() => {
                            setSidebarTitle("Ajouter un contrat");
                            setSidebarContent(
                                <ContractForm
                                    closeModal={() => setOpenSidebar(false)}
                                    profile={profile}
                                    refreshProfil={updateContracts}
                                    removeContract={(contract) =>
                                        setContracts((prev) =>
                                            prev.filter(
                                                (c) => c.id !== contract.id
                                            )
                                        )
                                    }
                                    onChange={({ contract }) => {
                                        setContracts((prev) => {
                                            const existingIndex =
                                                prev.findIndex(
                                                    (c) =>
                                                        c.id === contract.id
                                                );

                                            if (existingIndex !== -1) {
                                                const updated = [...prev];
                                                updated[existingIndex] =
                                                    contract;
                                                return updated;
                                            } else {
                                                return [...prev, contract];
                                            }
                                        });
                                    }}
                                />
                            );
                            setOpenSidebar(true);
                        }}
                        name={
                            <span className="flex items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 mr-1"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 4v16m8-8H4"
                                    />
                                </svg>
                                Ajouter un contrat
                            </span>
                        }
                    />
                </div>

                <div className="space-y-3">
                    {contracts && contracts.length > 0 ? (
                        contracts.map((contract) => {
                            return (
                                <ListElement
                                    key={contract.id}
                                    onClick={() => {
                                        setSidebarTitle("Modifier un contrat");
                                        setSidebarContent(
                                            <ContractForm
                                                contract={contract}
                                                closeModal={() =>
                                                    setOpenSidebar(false)
                                                }
                                                profile={profile}
                                                removeContract={(contract) =>
                                                    setContracts((prev) =>
                                                        prev.filter(
                                                            (c) =>
                                                                c.id !==
                                                                contract.id
                                                        )
                                                    )
                                                }
                                                onChange={({ contract }) => {
                                                    setContracts((prev) => {
                                                        const existingIndex =
                                                            prev.findIndex(
                                                                (c) =>
                                                                    c.id ===
                                                                    contract.id
                                                            );

                                                        if (
                                                            existingIndex !== -1
                                                        ) {
                                                            const updated = [
                                                                ...prev,
                                                            ];
                                                            updated[
                                                                existingIndex
                                                            ] = contract;
                                                            return updated;
                                                        } else {
                                                            return [
                                                                ...prev,
                                                                contract,
                                                            ];
                                                        }
                                                    });
                                                }}
                                                refreshProfil={updateContracts}
                                            />
                                        );
                                        setOpenSidebar(true);
                                    }}
                                    text={
                                        contract.type +
                                        " - " +
                                        new Intl.DateTimeFormat(
                                            "default",
                                            options
                                        ).format(
                                            new Date(contract.start_date)
                                        ) +
                                        (contract.end_date
                                            ? " - " +
                                            new Intl.DateTimeFormat(
                                                "default",
                                                options
                                            ).format(
                                                new Date(contract.end_date)
                                            )
                                            : "")
                                    }
                                    description={contract.name}
                                    info={
                                        (contract.user_work_shifts?.length || 0) +
                                        " cycle(s)"
                                    }
                                />
                            );
                        })
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-12 w-12 mx-auto mb-3 text-gray-400"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                />
                            </svg>
                            <p className="text-sm">Aucun contrat de travail</p>
                            <p className="text-xs text-gray-400 mt-1">
                                Cliquez sur "Ajouter un contrat" pour en créer un
                            </p>
                        </div>
                    )}
                </div>

            </div>

            {/* Opérations sur le planning (création ou suppression en cas de modification de cycle / de dates de contrat) */}
            {(showModalCreatePlanning || showModalDeletePlanning) && (
                <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
                    <div className="bg-white lg:rounded-2xl shadow-lg w-full h-full lg:max-w-2xl lg:h-auto p-6 space-y-4 space-x-2">
                        {showModalCreatePlanning &&
                            <>
                                <h2 className="text-xl font-semibold mb-4">Re-génération du planning prévisionnel</h2>
                                <DefaultDropdown
                                    key={"operation_create"}
                                    name={""}
                                    options={[{ label: "Ne rien faire", value: 0 }, { label: "Créer le planning sur les journées vides", value: 1 }, { label: "Ne pas modifier les absences", value: 2 }, { label: "Tout remplacer", value: 3 }]}
                                    value={planningCreateOperation}
                                    onChange={(e) => setPlanningCreateOperation(e.target.value)}
                                />
                                {planningCreateOperation > 0 &&
                                    <>
                                        <InputForm
                                            type="date"
                                            key={"date_creation_start"}
                                            name={"Date de début de création"}
                                            value={dateCreationStart}
                                            set={(e) => setDateCreationStart(e)}
                                        />
                                        <InputForm
                                            type="date"
                                            key={"date_creation_end"}
                                            name={"Date de fin de création"}
                                            value={dateCreationEnd}
                                            set={(e) => setDateCreationEnd(e)}
                                        />
                                    </>
                                }

                            </>
                        }

                        {showModalDeletePlanning &&
                            <>
                                <h2 className="text-xl font-semibold mb-4">Suppression du planning en dehors des dates de contrat</h2>
                                <DefaultDropdown
                                    key={"operation_delete"}
                                    name={""}
                                    options={[{ label: "Ne rien faire", value: 0 }, { label: "Supprimer le planning", value: 1 }]}
                                    value={planningDeleteOperation}
                                    onChange={(e) => setPlanningDeleteOperation(e.target.value)}
                                />
                            </>
                        }

                        <Button
                            name={"Valider"}
                            loading={isUpdatingPlanning}
                            action={async () => {
                                await updateProvisional();
                                setShowModalCreatePlanning(false);
                                setShowModalDeletePlanning(false);
                            }}
                        />
                    </div>
                </div>
            )}

            <SideBar
                title={sideBarTitle}
                content={sideBarContent}
                isOpen={openSideBar}
                onClose={() => {
                    setOpenSidebar(false);
                }}
            />
        </div>
    );
};

export default ContratsTab;

